import React, { useId } from 'react';
import { Box, BoxProps } from '@mui/material';

export type BrandLogoProps = {
  /** 外框边长（px） */
  size?: number;
  /** 无障碍标签 */
  title?: string;
} & Omit<BoxProps, 'children'>;

/**
 * 新领海知识库品牌标：开卷 + 领海弧线。
 * 矢量内联，登录页 / 侧栏共用，避免位图发糊。
 */
const BrandLogo: React.FC<BrandLogoProps> = ({
  size = 40,
  title = '新领海知识库',
  sx,
  ...rest
}) => {
  const gradId = `kbLogoBg-${useId().replace(/:/g, '')}`;

  return (
    <Box
      component="span"
      role="img"
      aria-label={title}
      sx={{
        width: size,
        height: size,
        display: 'inline-flex',
        flexShrink: 0,
        lineHeight: 0,
        borderRadius: size >= 48 ? '14px' : '10px',
        overflow: 'hidden',
        boxShadow:
          size >= 48
            ? '0 8px 24px rgba(37, 99, 235, 0.22)'
            : '0 1px 2px rgba(15, 23, 42, 0.06)',
        ...sx,
      }}
      {...rest}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <defs>
          <linearGradient id={gradId} x1="8" y1="4" x2="56" y2="60" gradientUnits="userSpaceOnUse">
            <stop stopColor="#1D4ED8" />
            <stop offset="1" stopColor="#2563EB" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill={`url(#${gradId})`} />
        <path
          d="M14 18.5C14 17.12 15.12 16 16.5 16H30v30.5c0 .83-.67 1.5-1.5 1.5H16.5C15.12 48 14 46.88 14 45.5V18.5Z"
          fill="white"
          fillOpacity="0.92"
        />
        <path
          d="M34 16h13.5C48.88 16 50 17.12 50 18.5v27c0 1.38-1.12 2.5-2.5 2.5H35.5c-.83 0-1.5-.67-1.5-1.5V16Z"
          fill="white"
          fillOpacity="0.78"
        />
        <path d="M32 16v32" stroke="#1D4ED8" strokeOpacity="0.35" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M19 24h8M19 29.5h7M19 35h8" stroke="#1D4ED8" strokeOpacity="0.45" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M37 24h8M37 29.5h7M37 35h5.5" stroke="#1D4ED8" strokeOpacity="0.28" strokeWidth="1.6" strokeLinecap="round" />
        <path
          d="M18 52c6.5-5.5 21.5-5.5 28 0"
          stroke="white"
          strokeOpacity="0.9"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
        <circle cx="46" cy="50.5" r="2.2" fill="#93C5FD" />
      </svg>
    </Box>
  );
};

export default BrandLogo;
